<!--景点类型-->
<template>
    <div class="ScenicSpot">
        <RButton v-for="(item,ix) in list" :color="item.select?'tourTypeGhost':'tourType'" :key="`select-tags-it-${ix}`"
                 @on-click="()=>onSelect(item.id,item.name,item.value,item.toastType,item.children,item.select)"><div class="scenic"><img :src="item.imgUrl" alt="" class="iconImg">{{item.name}}</div>
        </RButton>
    </div>
</template>

<script>
    import RButton from "../Use/r-button";

    export default {
        name: "ScenicSpot",
        components: {RButton},
        props: {
            list: {
                type: Array,
                default: []
            }

        },
        data() {
            return {};

        },
        methods: {
            onSelect(id, name, value,toastType,children,select) {
                this.$emit("on-select", name, value, id,toastType,children,select);
            }
        }
    };
</script>
<style lang="less" scoped>
    .ScenicSpot {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .scenic{
            display: flex;
            justify-content: flex-start;
            align-items: center;
        }
        .iconImg{
            width: 1rem;
            height: 1rem;
            margin-right: .2rem;
        }


    }

</style>
